export default __webpack_public_path__ + "static/media/img-id-barcode.907b3f55.svg";